// removed by extract-text-webpack-plugin
module.exports = {"card":"bq3aSkUsiKIl54sJipqvT","compact":"_252AWglA_EHFDnGvu6V7Hf","image":"_3U0uH2PYT4we9YUXUsy2QE","list":"LO-GcvNtDpE-Gt1K2UEnf","imageWrapper":"_2utJ0YsEp8DGrYr5EtwZRS","info":"_10nm4NKJgKGiYUkuxT5mJ2","hasImage":"_3eqqZu6lBE5QJMJMBCoGRB","name":"_1vxg5Zv6NxR6SeRoaiRVK0","address":"_1ze1oxXAUL8ovz__HXJW4Z","text":"_22_waWKVsKOqxnBPzQigpc","details":"_1nYPg-QVPrl0P-d0GcAqnh","region":"_1WwOfwlCHMahpI5f4uwrhQ","division":"_38h5LLjnFDOnQ5ssAxUyt0","externalUrl":"_1XwDJRcGpg5GDosrFtUe9U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCard/ProjectCard.module.scss
// module id = 796
// module chunks = 0